<div class="modal-content">
  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ status ? "Editar Status" : "Adicionar Status" }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="statusForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nome -->
      <div class="mb-3">
        <label class="form-label">Nome</label>
        <input
          class="form-control"
          placeholder="Digite o Nome de Usuário"
          type="text"
          formControlName="nome"
          [ngClass]="{
            'is-invalid':
              statusForm.controls.nome.touched &&
              statusForm.controls.nome.errors,
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            statusForm.controls.nome.touched && statusForm.controls.nome.errors
          "
        >
          O nome é obrigatório.
        </div>
      </div>

      <div class="col-6">
        <div class="dataTables_length" id="tickets-table_length">
          <label class="d-inline-flex align-items-center">
            Cor
            <select formControlName="cor" aria-controls="tickets-table" class="form-control form-control-sm mx-2">
              <option value="badge-soft-light">Cor Status Branco</option>
              <option value="badge-soft-primary">Cor Status Azul</option>
              <option value="badge-soft-secondary">Cor Status Cinza</option>
              <option value="badge-soft-success">Cor Status Verde</option>
              <option value="badge-soft-info">Cor Status Ciano</option>
              <option value="badge-soft-warning">Cor Status Amarelo</option>
              <option value="badge-soft-danger">Cor Status Vermelho</option>
              <option value="badge-soft-dark">Status Preto</option>
            </select>
          </label>
        </div>
      </div>

      <!-- Botão de Enviar -->
      <div class="text-end">
        <button type="submit" class="btn btn-sm btn-success">
          {{ status ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </form>
  </div>
</div>